/* eslint-disable  import/no-cycle -- need */
import { apiHandler } from '../utils/apiHandler';
import { combineDataFields, maskString, addToStaticTable } from '../utils/util';
import { entityOperations } from './CustomOperations/entityOperations';
import { validateJPGiftCardAmount } from './CustomOperations/japanGiftCardOperations';
import {
  invokeCalculateTransferpoints,
  invokeGetPartnerTransferRateandLabel,
} from './CustomOperations/mrtJapanOperations';
import { optionsFromExpandableTable } from './CustomOperations/expandableTableOperations';
import { deleteExpandableTablesData } from './CustomOperations/deleteExpandableTablesData';
import { transferFieldData } from './CustomOperations/transferFieldDataOperations';
import { decideJourneyType, populateHardshipSelectOptionLabel } from './CustomOperations/hardshipAuNz';
import { getNamePermutations } from './CustomOperations/getNamePermutationsOperation';

const setValue = require('lodash/set');
const getVal = require('lodash/get');
/* eslint-disable max-len -- need */
/* eslint-disable no-restricted-syntax -- need */
/* eslint-disable no-await-in-loop -- need */
/* eslint complexity: ["error", 55] -- need to increase complexity */
export const performOperations = async (props) => {
  /**
   * Operations like onChange, onBlur, onFocus, onClick, etc for different components can be performed here
   * Operations which invokes some specific functions or updates states can be managed here
   */
  const { operations, isValid = true } = props;
  for (const operation of operations) {
    const { requiresValid = true } = operation;
    if (requiresValid && !isValid) {
      // eslint-disable-next-line no-continue -- skip operations that require valid input
      continue;
    }
    switch (operation.type) {
      case 'combineFieldsAndAddToDataObject': {
        const newField = combineDataFields(operation.fieldsToCombine, props.dataObject);
        if (newField !== '') {
          operation.addField?.forEach((update) => {
            setValue(props.dataObject, `${update.to}.${update.addAs}`, newField);
          });
        }
        break;
      }
      case 'decideHardshipJourneyType': {
        decideJourneyType(props);
        break;
      }
      case 'populateHardshipSelectOptionLabel': {
        populateHardshipSelectOptionLabel(props);
        break;
      }
      case 'calculate_MRT_Transferpoints': {
        invokeCalculateTransferpoints({ ...props, operation });
        break;
      }
      case 'spreadObjectAndUpdateState': {
        const { functionObject } = props;
        const { dataObject } = props;
        const sourceObject = getVal(dataObject, operation.sourceObjectKey);
        const stateUpdateMethod = functionObject[operation.stateUpdateMethod];
        stateUpdateMethod((prevPayload) => {
          const newPayload = { ...prevPayload, ...sourceObject };
          if (operation.stateUpdateMethod === 'setFormSubmissionPayload') {
            newPayload.elemId = null;
          }
          return newPayload;
        });
        break;
      }
      case 'getPartnerTransferRateandLabel': {
        invokeGetPartnerTransferRateandLabel(props);
        break;
      }
      case 'callApi': {
        await apiHandler({ ...props, ...operation });
        break;
      }
      case 'Options_From_ExpandableTable': {
        optionsFromExpandableTable({ ...props, operation });
        break;
      }
      case 'Transfer_Field_Data': {
        transferFieldData({ ...props, operation });
        break;
      }
      case 'DeleteExpandableTablesData': {
        deleteExpandableTablesData({ ...props, operation });
        break;
      }
      case 'maskString': {
        const { dataObject, value } = props;
        const { maskParams } = operation;
        const {
          maskPattern, from, to, addAs,
        } = maskParams;
        const maskedValue = maskString({
          stringToMask: value, maskPattern, from, to,
        });
        setValue(dataObject, `formSubmissionPayload.${addAs}`, maskedValue);
        break;
      }
      case 'validateJPGiftCardAmount': {
        validateJPGiftCardAmount(props);
        break;
      }
      case 'addEntity':
      case 'removeEntity':
      case 'editEntity':
      case 'cancelEntityEdit':
      case 'toggleEntityField':
      {
        entityOperations({ props, entityOperationType: operation.type });
        break;
      }
      case 'updateDataOnS3': {
        props.functionObject.putDataToS3(operation.isPartialSubmit, null, operation.status);
        break;
      }
      case 'updatePayload': {
        const {
          value,
          functionObject,
          dataObject,
        } = props;
        let fetchedValue = value;
        const { setFormSubmissionPayload } = functionObject;
        const { keyToUpdate, value: operationValue, deleteKeyOnEmpty } = operation;
        if (operationValue) {
          fetchedValue = getVal(dataObject, operationValue);
        }
        if (fetchedValue || deleteKeyOnEmpty === false) {
          // Keep dataObject in sync for subsequent operations in the same loop (e.g. callApi)
          // because React state updates are async/batched.
          if (dataObject?.formSubmissionPayload) {
            dataObject.formSubmissionPayload[keyToUpdate] = fetchedValue;
          }
          setFormSubmissionPayload((prev) => ({ ...prev, elemId: null, [keyToUpdate]: fetchedValue }));
        } else {
          if (dataObject?.formSubmissionPayload) {
            delete dataObject.formSubmissionPayload[keyToUpdate];
          }
          setFormSubmissionPayload((prev) => {
            delete prev[keyToUpdate];
            return { ...prev, elemId: null };
          });
        }
        break;
      }
      case 'addToStaticTable': {
        addToStaticTable(props, operation.staticValues);
        break;
      }
      case 'getNamePermutations': {
        getNamePermutations(props);
        break;
      }
      case 'addDataFromSessionToPayload': {
        const {
          functionObject,
        } = props;
        const { setFormSubmissionPayload } = functionObject;
        const payloadUpdate = {};
        operation.sessionValues.forEach((session) => {
          payloadUpdate[session.addAs] = window.sessionStorage.getItem(session.sessionKey);
        });
        setFormSubmissionPayload((prev) => ({ ...prev, elemId: null, ...payloadUpdate }));
        break;
      }
      case 'filterArrayAndStore': {
        // Filters an array in formSubmissionPayload, finds the item matching selectedVal,
        // then stores full object and optional mapped keys from the match into the payload.
        // JSON config: { type, arrayPath, filterKey, storeAs, payloadKeyMapping }
        const { functionObject, dataObject, value: selectedVal } = props;
        const { setFormSubmissionPayload } = functionObject;
        const {
          arrayPath,
          filterKey,
          storeAs,
          payloadKeyMapping,
        } = operation;
        const array = getVal(dataObject, `formSubmissionPayload.${arrayPath}`) || [];
        const match = array.find((item) => String(getVal(item, filterKey)) === String(selectedVal));
        if (match) {
          const mappedPayload = {};
          if (payloadKeyMapping && typeof payloadKeyMapping === 'object') {
            Object.entries(payloadKeyMapping).forEach(([targetKey, sourcePath]) => {
              mappedPayload[targetKey] = getVal(match, sourcePath);
            });
          }

          setFormSubmissionPayload((prev) => ({
            ...prev,
            elemId: null,
            [storeAs]: match,
            ...mappedPayload,
          }));
        }
        break;
      }
      case 'setStaticPayloadValues': {
        // Merges a fixed set of key-value pairs into formSubmissionPayload.
        // Use this when you need to write a hardcoded/static value (e.g. a boolean flag)
        // on any component event (onChange, onClick, etc.).
        //
        // JSON config example:
        // {
        //   "type": "setStaticPayloadValues",
        //   "staticValues": { "arketeamTaxCall": true, "someFlag": "fixed-string" }
        // }
        const { functionObject, dataObject } = props;
        const { setFormSubmissionPayload } = functionObject;
        if (operation.staticValues && typeof operation.staticValues === 'object') {
          // Keep dataObject in sync for subsequent operations in the same loop (e.g. callApi)
          // because React state updates are async/batched.
          if (dataObject?.formSubmissionPayload) {
            Object.assign(dataObject.formSubmissionPayload, operation.staticValues);
          }
          setFormSubmissionPayload((prev) => ({ ...prev, ...operation.staticValues }));
        }
        break;
      }
      case 'prefillFieldsFromSelectedOption': {
        const {
          functionObject,
          dataObject,
        } = props;
        const {
          selectedVal,
        } = dataObject;
        const { setFormSubmissionPayload } = functionObject;
        const selectionRules = operation.selectionRules || [];
        const clearOnNoMatch = operation.clearOnNoMatch !== false;
        const sourceDataPaths = Array.isArray(operation.sourceDataPaths) && operation.sourceDataPaths.length > 0
          ? operation.sourceDataPaths
          : ['formSubmissionPayload'];
        const sourceDataObjects = sourceDataPaths.reduce((sources, path) => {
          const sourceObject = getVal(dataObject, path);
          if (sourceObject && typeof sourceObject === 'object') {
            sources.push(sourceObject);
          }
          return sources;
        }, []);
        const selectedValStr = String(selectedVal || '').trim();

        let matchedRule = null;
        let matchedIndex = null;

        selectionRules.some((rule) => {
          const patternSources = Array.isArray(rule.matchPatterns) && rule.matchPatterns.length > 0
            ? rule.matchPatterns
            // eslint-disable-next-line no-extra-parens -- parens required by unicorn/no-nested-ternary
            : (rule.matchPattern ? [rule.matchPattern] : []);

          if (patternSources.length === 0) {
            return false;
          }

          const matched = patternSources.reduce((result, patternSource) => {
            if (result) {
              return result;
            }
            try {
              return selectedValStr.match(new RegExp(patternSource));
            } catch (e) {
              return null;
            }
          }, null);

          if (!matched) {
            return false;
          }
          const indexGroup = Number.isInteger(rule.indexGroup) ? rule.indexGroup : 1;
          matchedRule = rule;
          matchedIndex = matched[indexGroup];
          return true;
        });

        const targetFields = selectionRules.reduce((acc, rule) => {
          const mappings = rule.fieldMappings || [];
          mappings.forEach((mapping) => {
            if (mapping.toFieldId) {
              acc.push(mapping.toFieldId);
            }
          });
          return acc;
        }, []);

        const payloadUpdate = {};

        if (matchedRule) {
          (matchedRule.fieldMappings || []).forEach((mapping) => {
            if (!mapping.toFieldId) {
              return;
            }

            const fromTemplates = Array.isArray(mapping.fromFieldTemplates) && mapping.fromFieldTemplates.length > 0
              ? mapping.fromFieldTemplates
              // eslint-disable-next-line no-extra-parens -- parens required by unicorn/no-nested-ternary
              : (mapping.fromFieldTemplate ? [mapping.fromFieldTemplate] : []);

            if (fromTemplates.length === 0) {
              return;
            }

            let mappedValue = '';
            const capturedMatchedIndex = matchedIndex;
            for (const sourceObject of sourceDataObjects) {
              const resolvedValue = fromTemplates.reduce((result, template) => {
                if (typeof result !== 'undefined' && result !== null && result !== '') {
                  return result;
                }
                const fromFieldId = template.replace('{index}', capturedMatchedIndex);
                return getVal(sourceObject, fromFieldId);
              }, undefined);

              if (typeof resolvedValue !== 'undefined' && resolvedValue !== null && resolvedValue !== '') {
                mappedValue = resolvedValue;
                break;
              }
            }

            // Array-path fallback: if no flat-key value found, read from nested API array
            if (mappedValue === '' && mapping.fromArrayField && Array.isArray(matchedRule.fromArrayPaths)) {
              const arrayIndex = Number(matchedIndex) - 1;
              if (arrayIndex >= 0) {
                const arrayRecord = matchedRule.fromArrayPaths.reduce((record, arrayPath) => {
                  if (record !== undefined && record !== null) return record;
                  const arr = getVal(sourceDataObjects[0], arrayPath);
                  return Array.isArray(arr) ? arr[arrayIndex] : undefined;
                }, undefined);
                if (arrayRecord !== undefined && arrayRecord !== null) {
                  const arrayFieldValue = getVal(arrayRecord, mapping.fromArrayField);
                  if (typeof arrayFieldValue !== 'undefined' && arrayFieldValue !== null && arrayFieldValue !== '') {
                    mappedValue = arrayFieldValue;
                  }
                }
              }
            }

            payloadUpdate[mapping.toFieldId] = mappedValue;
          });
        } else if (clearOnNoMatch) {
          targetFields.forEach((fieldId) => {
            payloadUpdate[fieldId] = '';
          });
        }

        if (Object.keys(payloadUpdate).length > 0 && setFormSubmissionPayload) {
          setFormSubmissionPayload((prev) => ({ ...prev, elemId: null, ...payloadUpdate }));
        }
        break;
      }
      case 'combineArraysToObjectArray': {
        const { functionObject } = props;
        const { dataObject } = props;
        const { sourceArrays, targetKey } = operation;
        const arrays = sourceArrays.map((src) => getVal(dataObject, src.path) || []);
        const allSameLength = arrays.every((arr) => arr.length === arrays[0].length);
        if (allSameLength && arrays[0].length > 0) {
          const result = arrays[0].map((_, index) => {
            const obj = {};
            sourceArrays.forEach((src, idx) => {
              obj[src.mapAs] = arrays[idx][index] || '';
            });
            return obj;
          });
          const stateUpdateMethod = functionObject[operation.stateUpdateMethod || 'setFormSubmissionPayload'];
          stateUpdateMethod((prevPayload) => {
            const newPayload = { ...prevPayload, [targetKey]: result };
            if ((operation.stateUpdateMethod || 'setFormSubmissionPayload') === 'setFormSubmissionPayload') {
              newPayload.elemId = null;
            }
            return newPayload;
          });
        }
        break;
      }
      default:
    }
  }
};
/* eslint-enable no-await-in-loop -- need */
/* eslint-enable no-restricted-syntax -- need */
/* eslint-enable max-len -- need */
/* eslint-enable  import/no-cycle -- need */
